import { json } from "@hyper-hyper-space/hhs3_json";
import { renderOp } from "./render.js";
export function firstNonCommentLine(sql) {
    var _a;
    const lines = sql.split('\n');
    for (const line of lines) {
        if (!line.startsWith('--'))
            return line;
    }
    return (_a = lines[0]) !== null && _a !== void 0 ? _a : '';
}
export function renderLogOpLine(payload, prev, options) {
    const sql = renderOp(payload, Object.assign(Object.assign({}, options), { aliasMode: false, comments: false, profile: 'full', at: json.toSet(prev) }));
    return firstNonCommentLine(sql);
}
